export let ConnectorName;

(function (ConnectorName) {
  ConnectorName["METAMASK"] = "Metamask";
  ConnectorName["COINBASE"] = "Coinbase";
  ConnectorName["THETAN_WALLET"] = "ThetanWallet";
  ConnectorName["INJECTED"] = "Injected";
})(ConnectorName || (ConnectorName = {}));

export let RpcErrorCode;

(function (RpcErrorCode) {
  RpcErrorCode[RpcErrorCode["PARSE_ERROR"] = -32700] = "PARSE_ERROR";
  RpcErrorCode[RpcErrorCode["INVALID_REQUEST"] = -32600] = "INVALID_REQUEST";
  RpcErrorCode[RpcErrorCode["METHOD_NOT_FOUND"] = -32601] = "METHOD_NOT_FOUND";
  RpcErrorCode[RpcErrorCode["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
  RpcErrorCode[RpcErrorCode["INTERNAL_ERROR"] = -32603] = "INTERNAL_ERROR";
  RpcErrorCode[RpcErrorCode["INVALID_INPUT"] = -32000] = "INVALID_INPUT";
  RpcErrorCode[RpcErrorCode["RESOURCE_NOT_FOUND"] = -32001] = "RESOURCE_NOT_FOUND";
  RpcErrorCode[RpcErrorCode["RESOURCE_UNAVAILABLE"] = -32002] = "RESOURCE_UNAVAILABLE";
  RpcErrorCode[RpcErrorCode["TRANSACTION_REJECTED"] = -32003] = "TRANSACTION_REJECTED";
  RpcErrorCode[RpcErrorCode["METHOD_NOT_SUPPORTED"] = -32004] = "METHOD_NOT_SUPPORTED";
  RpcErrorCode[RpcErrorCode["LIMIT_EXCEEDED"] = -32005] = "LIMIT_EXCEEDED";
  RpcErrorCode[RpcErrorCode["JSON_RPC_VERSION_NOT_SUPPORTED"] = -32006] = "JSON_RPC_VERSION_NOT_SUPPORTED";
  RpcErrorCode[RpcErrorCode["USER_REJECTED_REQUEST"] = 4001] = "USER_REJECTED_REQUEST";
  RpcErrorCode[RpcErrorCode["USER_UNAUTHORIZED"] = 4100] = "USER_UNAUTHORIZED";
  RpcErrorCode[RpcErrorCode["UNSUPPORTED_METHOD"] = 4200] = "UNSUPPORTED_METHOD";
  RpcErrorCode[RpcErrorCode["DISCONNECTED"] = 4900] = "DISCONNECTED";
  RpcErrorCode[RpcErrorCode["CHAIN_DISCONNECTED"] = 4901] = "CHAIN_DISCONNECTED";
  RpcErrorCode[RpcErrorCode["CHAIN_NOT_FOUND"] = 4902] = "CHAIN_NOT_FOUND";
})(RpcErrorCode || (RpcErrorCode = {}));

export const BNB_CHAIN_INFO = {
  chainName: 'Binance Smart Chain',
  chainId: 56
};
export const defaultChains = [{
  id: 56,
  name: 'Binance Smart Chain',
  network: 'BSC',
  nativeCurrency: {
    decimals: 18,
    name: 'Binance Coin',
    symbol: 'BNB'
  },
  rpcUrls: {
    default: 'https://bsc-dataseed.binance.org/'
  },
  blockExplorers: {
    default: {
      name: 'BSCscan',
      url: 'https://bscscan.com'
    }
  }
}, {
  id: 97,
  name: 'Binance Smart Chain - Testnet',
  network: 'BSC Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Binance Coin',
    symbol: 'BNB'
  },
  rpcUrls: {
    default: 'https://nodes.sequence.app/bsc-testnet'
  },
  blockExplorers: {
    default: {
      name: 'BSCscan',
      url: 'https://testnet.bscscan.com'
    }
  },
  testnet: true
}];
// https://ethereum.org/en/developers/docs/standards/tokens/erc-20
export const erc20ABI = ['event Approval(address indexed _owner, address indexed _spender, uint256 _value)', 'event Transfer(address indexed _from, address indexed _to, uint256 _value)', 'function allowance(address _owner, address _spender) public view returns (uint256 remaining)', 'function approve(address _spender, uint256 _value) public returns (bool success)', 'function balanceOf(address _owner) public view returns (uint256 balance)', 'function decimals() public view returns (uint8)', 'function name() public view returns (string)', 'function symbol() public view returns (string)', 'function totalSupply() public view returns (uint256)', 'function transfer(address _to, uint256 _value) public returns (bool success)', 'function transferFrom(address _from, address _to, uint256 _value) public returns (bool success)']; // https://ethereum.org/en/developers/docs/standards/tokens/erc-721

export const erc721ABI = ['event Approval(address indexed _owner, address indexed _approved, uint256 indexed _tokenId)', 'event ApprovalForAll(address indexed _owner, address indexed _operator, bool _approved)', 'event Transfer(address indexed _from, address indexed _to, uint256 indexed _tokenId)', 'function approve(address _approved, uint256 _tokenId) external payable', 'function balanceOf(address _owner) external view returns (uint256)', 'function getApproved(uint256 _tokenId) external view returns (address)', 'function isApprovedForAll(address _owner, address _operator) external view returns (bool)', 'function name() view returns (string memory)', 'function ownerOf(uint256 _tokenId) external view returns (address)', 'function safeTransferFrom(address _from, address _to, uint256 _tokenId) external payable', 'function safeTransferFrom(address _from, address _to, uint256 _tokenId, bytes data) external payable', 'function setApprovalForAll(address _operator, bool _approved) external', 'function symbol() view returns (string memory)', 'function tokenByIndex(uint256 _index) view returns (uint256)', 'function tokenOfOwnerByIndex(address _owner, uint256 _index) view returns (uint256 tokenId)', 'function tokenURI(uint256 _tokenId) view returns (string memory)', 'function totalSupply() view returns (uint256)', 'function transferFrom(address _from, address _to, uint256 _tokenId) external payable']; // https://github.com/ethers-io/ethers.js/blob/master/packages/units/src.ts/index.ts#L10-L18

export const units = ['wei', 'kwei', 'mwei', 'gwei', 'szabo', 'finney', 'ether'];